import _sfc_main from './infinite-scroll.vue2.js';
/* empty css                    */
import _export_sfc from '../../_virtual/_plugin-vue_export-helper.js';

const InfiniteScroll = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-0d30e324"]]);

export { InfiniteScroll as default };
//# sourceMappingURL=infinite-scroll.js.map
